// My页面相关的类型定义和枚举

export enum MenuItemType {
  NAVIGATION = 'navigation',
  ACTION = 'action',
  SETTING = 'setting'
}

export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  SUSPENDED = 'suspended'
}

export interface MenuItem {
  id: string
  type: MenuItemType
  label: string
  icon: string
  route?: string
  action?: () => void
}

export interface UserProfile {
  id: string
  name: string
  email: string
  avatar?: string
  status: UserStatus
  kycLevel: number
}

// 卡片操作类型枚举
export enum CardActionType {
  Safety = 'safety',
  Lang = 'lang',
  Help = 'question',
  About = 'about'
}

// 卡片操作项接口
export interface CardActionItem {
  icon: string
  title: string
  actionType: CardActionType
}